export enum UnitOperationReadiness {
  UNDEFINED = 'undefined',
  NOT_FULLY_CONNECTED = 'not-fully-connected',
  NOT_FULLY_SPECIFIED = 'not-fully-specified',
  READY = 'ready',
}
